module.exports = __webpack_public_path__ + "static/media/wcgMimosas.cedf257d.jpg";